import React from "react";
import noticeTypeToRussian from "../../../../constants/noticeTypeToRussian";
import DefaultDatePicker from "./DefaultDatePicker";
import NoticeText from "./NoticeText";

const PhoneSettings = ({ templates }) => {
	return (
		<div style={{ position: "relative" }}>
			<span className="type_name">{noticeTypeToRussian["PHONE"]}</span>
			<DefaultDatePicker type="PHONE" />
			<NoticeText templates={templates} fieldKey="PhoneTemplateId" />
		</div>
	);
};

export default PhoneSettings;
